<template>
  <div>
        <div>
            <PadorReset v-if="login == 1" />
            <LoginFloatReset v-else />
        </div>
  </div>
  
</template>

<script>
import PadorReset from './Default/reset_password'
import LoginFloatReset from './LoginFloat/reset_password'

export default {
    components: {
        PadorReset,
        LoginFloatReset
    },
    data(){
      return{
        login: 1,
        domain: null
      }
    },
    mounted(){
      this.domain = JSON.parse(localStorage.getItem('@datadrive:domain'))
      this.login = this.domain.entityLayoutID

      if(!this.domain){
        location.reload();
      }
    }
}
</script>
